import { Toaster } from 'react-hot-toast';

import { StoreProvider } from './store/StoreContext';
import { ThemeProvider } from './theme/theme-provider';
import { Router } from './routes/sections';
import './global.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { useScrollToTop } from './hooks/use-scroll-to-top';
import { LoadingProvider } from './store/loadingContext';
import { GlobalLoadingOverlay } from './components/loading';


export default function App() {
  useScrollToTop();
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StoreProvider>
        <ThemeProvider>
          <LoadingProvider>
            <Router />
            <GlobalLoadingOverlay />
            <Toaster />
          </LoadingProvider>
        </ThemeProvider>
      </StoreProvider>
    </LocalizationProvider>
  );
}
